import Siprec from './factory/Siprec'
import Locale from '@/locale'

export default Siprec({
  name: 'numbers',
  enums: {
    recordingType: {
      RECORD_ALWAYS: Locale.t('recordingType.always'),
      RECORD_NEVER: Locale.t('recordingType.never')
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/Number.js